export default "__VITE_ASSET__Uy1lreEO__"